export enum PdfSidebarView {
  THUMBS = 1, // Default value.
  OUTLINE = 2,
  ATTACHMENTS = 3,
  LAYERS = 4,
}
